import { render, staticRenderFns } from "./policyfile.vue?vue&type=template&id=eca29674&scoped=true&"
import script from "./policyfile.vue?vue&type=script&lang=js&"
export * from "./policyfile.vue?vue&type=script&lang=js&"
import style0 from "./policyfile.vue?vue&type=style&index=0&id=eca29674&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca29674",
  null
  
)

export default component.exports